<template>
  <VacancyContainer
    :id="vacancyId"
    v-slot="{ company, vacancy }"
    @ready="handleVacancyContainerReady"
  >
    <VRow justify="center">
      <VCol cols="12" md="3" lg="3" xl="2">
        <CompanySmallCard :company="company" />
      </VCol>
      <VCol cols="12" md="8">
        <VCard>
          <CandidateProfileForm
            :vacancy="vacancy"
            :candidate="candidate"
            :without-invitation="true"
            @done="pushToSuccessForm"
          />
        </VCard>
      </VCol>
    </VRow>
  </VacancyContainer>
</template>

<script>
import VacancyContainer from '../components/Vacancy/VacancyContainer.vue';
import CompanySmallCard from '../components/Company/CompanySmallCard.vue';
import CandidateProfileForm from '../forms/CandidateProfileForm.vue';
import { safeGet } from '../functions';

export default {
  name: 'ApplyOnVacancy',
  components: {
    VacancyContainer,
    CompanySmallCard,
    CandidateProfileForm,
  },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    candidate() {
      const candidate = safeGet(this.$store.state.candidate, ['data', 'candidate']);

      if (!candidate || candidate.vacancyId !== this.vacancyId) {
        return null;
      }

      return candidate;
    },
  },
  async created() {
    this.calculateHeight();
  },
  methods: {
    handleVacancyContainerReady({ vacancy }) {
      this.pageTitle = `${this.$t('pageTitle')} ${vacancy.title}`;
    },
    pushToSuccessForm() {
      this.$router.push({ name: 'applyOnVacancySuccess', params: { vacancyId: this.vacancyId } });
    },
    calculateHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = document.documentElement.scrollHeight;
          if (document.documentElement.offsetHeight > height) {
            height = document.documentElement.offsetHeight;
          }
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage({ height }, '*');
        }, 1000);
      });
    },
  },
};
</script>

<style scoped>

</style>
